/*
 * @Date: 2022-07-05 19:59:01
 * @LastEditors: chuhongguang
 * @desc: 首页
 */
import DefaultLayout from '@/layout/index'

const baseLangKey = 'layout.headerBar';

export default {
  name: 'home',
  path: '/',
  redirect: '/index',
  component: DefaultLayout,
  children: (pre => 
    [
      {
        path: '/index',
        name: `${pre}index`,
        meta: {
          title: '公司概览',
          langKey: baseLangKey + '.home'
        },
        component: () => import('@/views/home/index.vue')
      },
    ]
  )('home-')
}